import { APICore } from "../apiCore";

const api = new APICore();

function search(term, guild) {
    return api.update('/search', { term, guild });
}

export { search };
